import {useDebugValue} from 'react';

import {noop} from '../../../utils/noop';

import {useEvents} from './useEvents';

const defaultSubmitDetailsEvents = {
    onClick: noop
};

function useSubmitDetailsEvents(props) {
    const {
        submitDetailsEvents: propsSubmitDetailsEvents
    } = props;

    const {
        events: submitDetailsEvents
    } = useEvents(defaultSubmitDetailsEvents, propsSubmitDetailsEvents);

    const result = {
        submitDetailsEvents
    };

    useDebugValue(result);

    return result;
}

export {useSubmitDetailsEvents};
